import { useAsyncError } from '@/context/async-error-boundary';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

export function useMutationWithErrorBoundary<
    TData,
    TError extends Error,
    TVariables,
>(
    options: UseMutationOptions<TData, TError, TVariables>,
    errorBoundary?: { captureError?: (error: Error) => void },
) {
    const asyncError = useAsyncError();
    const captureError = errorBoundary?.captureError || asyncError.captureError;

    return useMutation<TData, TError, TVariables>({
        ...options,
        onError: (error, variables, onMutateResult, context) => {
            // Capture error to trigger error boundary
            captureError(error as Error);

            // Call original onError if provided
            options.onError?.(error, variables, onMutateResult, context);
        },
    });
}
